import {createContext} from 'react';

// @ts-ignore
export const GeneralContext = createContext();